var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5003 114.518C90.3335 114.518 114.518 90.3335 114.518 60.5003C114.518 30.667 90.3335 6.48242 60.5003 6.48242C30.667 6.48242 6.48242 30.667 6.48242 60.5003C6.48242 90.3335 30.667 114.518 60.5003 114.518Z",
    fill: "#84C70D",
    fillOpacity: 0.2,
    stroke: "#84C70D",
    strokeWidth: 12.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8926 65.9015L54.6069 82.1069C62.0014 60.8655 68.1597 51.5445 82.1069 38.8926",
    stroke: "#84C70D",
    strokeWidth: 12.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.a00d2dd3153986f213051818a20446f8.svg";
export { ForwardRef as ReactComponent };